module.exports = __webpack_public_path__ + "static/media/icon_menu.db12a6b7.svg";